import React, { useState, useEffect } from 'react'
import {
	Box,
	Typography,
	TextField,
	Button,
	Paper,
	Container,
	ThemeProvider,
	createTheme,
	InputAdornment,
} from '@mui/material'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import PasswordIcon from '@mui/icons-material/Password'

const theme = createTheme({
	palette: {
		primary: {
			main: '#2196f3',
		},
		secondary: {
			main: '#f50057',
		},
	},
	typography: {
		fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
		h1: {
			fontSize: '6rem',
			fontWeight: 300,
			letterSpacing: '-0.01562em',
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: 8,
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					borderRadius: 16,
				},
			},
		},
	},
})

const CountdownPage = () => {
	const [input, setinput] = useState('')
	const [seconds, setSeconds] = useState(0)
	const [isActive, setIsActive] = useState(false)
	const [isSolved, setIsSolved] = useState(false)
	const [inputError, setInputError] = useState('')

	useEffect(() => {
		let interval = null

		if (isActive && seconds > 0) {
			interval = setInterval(() => {
				setSeconds((seconds) => seconds - 1)
			}, 1000)
		} else if (isActive && seconds === 0) {
			setIsActive(false)
			alert('Countdown complete!')
		}

		return () => clearInterval(interval)
	}, [isActive, seconds])

	const handleMinutesChange = (e) => {
		const value = e.target.value
		setinput(value)
		setInputError('')
	}

	const startCountdown = (minutes) => {
		if (!minutes) {
			setInputError('Please enter a valid time in minutes')

			return
		}

		const totalSeconds = minutes * 60

		if (totalSeconds <= 0) {
			setInputError('Please enter a value greater than 0')

			return
		}

		setSeconds(totalSeconds)
		setIsActive(true)
		setinput('')
		setInputError('')
	}

	const parseInput = () => {
		if (input?.startsWith('time')) {
			const minutes = parseInt(input.slice(5), 10)
			startCountdown(minutes)
			setinput('')
		}

		if (input === '9f73q41622Y14+306814') {
			return
		}

		return
	}

	const formatTime = () => {
		const mins = Math.floor(seconds / 60)
		const secs = seconds % 60

		return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
	}

	return (
		<ThemeProvider theme={theme}>
			<Container maxWidth="lg">
				<Box
					sx={{
						minHeight: '100vh',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						py: 4,
					}}
				>
					<Paper
						elevation={6}
						color="primary"
						sx={{
							width: '100%',
							p: 4,
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<Typography
							variant="h4"
							component="h1"
							gutterBottom
							align="center"
							sx={{ fontWeight: 500, mb: 3 }}
						>
							Azura
						</Typography>

						<Box
							sx={{
								bgcolor: 'grey.900',
								borderRadius: 4,
								p: { xs: 3, md: 6 },
								mb: 4,
								width: '100%',
								display: 'flex',
								justifyContent: 'center',
								boxShadow: 3,
							}}
						>
							<Typography
								variant="h1"
								component="div"
								align="center"
								color="error"
								sx={{
									fontFamily: "'Digital-7', 'Digital-7 Mono', monospace",
									fontWeight: 700,
									fontSize: { lg: '10rem' },
									letterSpacing: 9,
								}}
							>
								{isActive ? formatTime() : '00:00'}
							</Typography>
						</Box>

						<TextField
							fullWidth
							variant="outlined"
							label="Minutes"
							value={input}
							onChange={handleMinutesChange}
							disabled={isSolved}
							error={!!inputError}
							helperText={inputError}
							type="text"
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<PasswordIcon />
									</InputAdornment>
								),
							}}
							sx={{ mb: 3 }}
							placeholder="Enter password"
						/>

						<Button
							variant="contained"
							color="error"
							size="large"
							disabled={isSolved}
							onClick={parseInput}
							startIcon={<LockOpenIcon />}
							sx={{
								py: 1.5,
								px: 4,
								fontSize: '1.2rem',
								fontWeight: 'bold',
								width: '100%',
							}}
						>
							ENTER
						</Button>
					</Paper>
				</Box>
			</Container>
		</ThemeProvider>
	)
}

export default CountdownPage
